"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SectionNotificationConsumer = exports.SectionNotificationProvider = void 0;
var React = require("react");
var context = React.createContext({
    type: 'default',
});
exports.SectionNotificationProvider = context.Provider;
exports.SectionNotificationConsumer = context.Consumer;
//# sourceMappingURL=SectionNotificationContext.js.map